import { isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonComponent } from '../../common/common.component';

@Component({
    selector: 'app-richieste-generiche-popup',
    templateUrl: './richieste-generiche-popup.component.html',
    styleUrls: ['./richieste-generiche-popup.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgClass, NgIf]
})
export class RichiesteGenerichePopupComponent extends CommonComponent implements OnInit {
  formIsSubmit = false;
  @Input() regione = '';
  @Input() provincia = '';
  @Input() comune = '';
  @Input() zona = '';
  @Input() searchValue = '';
  @Input() genericRequestPopupIsOpen = false;
  @Input() loadPopup = false;
  @Output() closeGenPopupEvt = new EventEmitter<boolean>();
  @Output() submitGenPopupEvt = new EventEmitter<boolean>();

  get reqForm(): any {
    return this.genericRequestForm.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public authenticationService: AuthenticationService,
    public main: AppComponent,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    super(authenticationService);
  }

  genericRequestForm = this.formBuilder.group({
    name: [''],
    surname: [''],
    email: [''],
    phone_number: [''],
    message: ['', Validators.required],
    accepts_terms_and_conditions: [true, Validators.requiredTrue],
  });

  ngOnInit(): void {
    this.genericRequestForm.patchValue({
      name: this.currentUser?.first_name,
      surname: this.currentUser?.last_name,
      phone_number: this.currentUser?.phone_number,
      email: this.currentUser?.email,
    });
  }

  closeGenPopup(): void {
    this.genericRequestForm.controls.message.setValue('');
    this.closeGenPopupEvt.emit();
  }

  submitGenPopup(): void {
    this.formIsSubmit = true;
    this.submitGenPopupEvt.emit(this.genericRequestForm.controls.message.value);
  }

  // SE L'UTENTE CLICCA FUORI DAL POPUP VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    if (isPlatformBrowser(this.platformId)) {
      if (target.classList.contains('bg-modal')) {
        this.closeGenPopup();
      }
    }
  }

  createAgentLabel(searchRegione: string, searchProvincia: string, searchComune: string, searchZona: string, searchValue: string): string {
    if (searchRegione) {
      return `della regione ${searchRegione.charAt(0).toUpperCase() + searchRegione.slice(1)}`;
    }
    if (searchProvincia) {
      return `della provincia di ${searchProvincia.charAt(0).toUpperCase() + searchProvincia.slice(1)}`;
    }
    if (searchComune) {
      return `di ${searchComune.charAt(0).toUpperCase() + searchComune.slice(1)}`;
    }
    if (searchZona) {
      return `della zona ${searchZona.charAt(0).toUpperCase() + searchZona.slice(1)}`;
    }
    if (searchValue) {
      return `della zona di ${this.searchValue.split(',')[0]}`;
    }
    return 'della zona';
  }
}
